var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var toPct = function (base) {
    return base * 100 + "%";
};
// The layout is based on a 12-column grid
var cols = {
    one: 1 / 12,
    two: 2 / 12,
    three: 3 / 12,
    four: 4 / 12,
    five: 5 / 12,
    six: 6 / 12,
    seven: 7 / 12,
    eight: 8 / 12,
    nine: 9 / 12,
    ten: 10 / 12,
    eleven: 11 / 12,
    twelve: 12 / 12,
};
var sizes = __spreadArrays([
    '0'
], Object.values(cols)
    .sort(function (a, b) { return a - b; })
    .map(function (col) { return toPct(col); }));
export default sizes;
//# sourceMappingURL=sizes.js.map